import request from '../helpers/request'

export default {
  getEvents: async ids => {
    const { data } = await request.get('/shop/catalog/get-events/', { params: { cities_ids: ids } })

    return data
  }
}
